/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputChatMessageUser
 */
export interface OutputChatMessageUser {
    /**
     * 
     * @type {number}
     * @memberof OutputChatMessageUser
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputChatMessageUser
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OutputChatMessageUser
     */
    title: string;
}

/**
 * Check if a given object implements the OutputChatMessageUser interface.
 */
export function instanceOfOutputChatMessageUser(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    if (!('title' in value)) return false;
    return true;
}

export function OutputChatMessageUserFromJSON(json: any): OutputChatMessageUser {
    return OutputChatMessageUserFromJSONTyped(json, false);
}

export function OutputChatMessageUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputChatMessageUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'title': json['title'],
    };
}

export function OutputChatMessageUserToJSON(value?: OutputChatMessageUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'title': value['title'],
    };
}

